import React from "react";
import { ChevronRightMini, HomeMicroFill } from "../../assets/SvgIcons";
import { Link } from "react-router-dom";

const ExploreBrandsNavbar = () => {
  return (
    <nav className="max-w-[1200px] mx-auto ">
      <div className="flex gap-2 text-[12px] lg:px-2 md:px-4 sm:px-4 mt-4">
        {/* Home Icon Link */}
        <Link to="/">{HomeMicroFill}</Link>

        {/* External Link Icon and Text */}
        {ChevronRightMini}
        <span className="text-ellipsis" title="Rolex watches">
          Rolex watches
        </span>
      </div>
    </nav>
  );
};

export default ExploreBrandsNavbar;
